/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {
  const model_autocomplete_target = $(".equipement_model_autocomplete");

  if (model_autocomplete_target.length > 0) {
    const dataSet = {
      name: "model-list",
      source(query, cb) {
        return $.get(model_autocomplete_target.data("source"), {query}, data => cb(data.options));
      }
    };

    const options = {
      debug: false,
      minLength: 2,
      autoselect: true
    };

    model_autocomplete_target.autocomplete(options, dataSet);
    model_autocomplete_target.on("autocomplete:selected", (event, suggestion, source) => window.location = suggestion.url);

    return $("#clear_equipement_model_autocomplete").on("click", function(event) {
      event.preventDefault();
      return model_autocomplete_target.val('');
    });
  }
});